module.exports = __webpack_public_path__ + "img/logos-tarjetas.1252615b.png";